module.exports = __webpack_public_path__ + "static/Frys_pin_hover-52aacd233d62f7a1665d84290da96c1a.png";